import React from 'react';
import { onAuthUIStateChange } from '@aws-amplify/ui-components';
import Page from './components/Page';

function AuthStateApp() {
  const [authState, setAuthState] = React.useState();
  const [user, setUser] = React.useState();

  React.useEffect(() => {
    return onAuthUIStateChange((nextAuthState, authData) => {
      setAuthState(nextAuthState);
      setUser(authData);
    });
  }, []);


  return <Page authState={authState} user={user} />;
}

export default AuthStateApp;
